import React from "react";
import classNames from "classnames";

import styles from "./DivideSection.module.scss";
import { NormalSection } from "../NormalSection";

interface DivideSectionProps {
  left: React.ReactNode;
  leftClassName?: string;
  right: React.ReactNode;
  rightClassName?: string;
  lineBetween?: boolean;
  clipped?: boolean;
}

const DivideSection: React.FC<DivideSectionProps> = ({
  left,
  right,
  lineBetween,
  leftClassName,
  rightClassName,
  clipped,
}) => {
  return (
    <NormalSection
      className={classNames(
        styles.section,
        { [styles.line]: lineBetween },
        { [styles.clipped]: clipped }
      )}
    >
      <div className={classNames(styles.left, leftClassName)}>{left}</div>
      <div className={classNames(styles.right, rightClassName)}>{right}</div>
    </NormalSection>
  );
};

export { DivideSection };
